export default __webpack_public_path__ + "static/media/correos-express.07f15110.svg";